import { Link2 } from 'lucide-react';

import { NodeShell } from './NodeShell';

import type { TrackingLinkNodeData } from '@repo/shared-types';

export const TrackingLinkNode = ({
  data,
  selected,
}: {
  data: TrackingLinkNodeData;
  selected?: boolean;
}) => (
  <NodeShell
    type="tracking_link"
    icon={<Link2 size={16} />}
    label={data.label}
    subtitle={data.url || undefined}
    selected={selected}
  />
);
